module.exports = __webpack_public_path__ + "images/emoji/clock2.ef19898c9eba277fdb36.png";